import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CoreComponent} from '../../../core/core.component';
import {NgForm} from '@angular/forms';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PlaceOfApplication} from './place-of-application';
import {PlacesOfApplicationService} from '../places-of-application.service';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Meta, Title} from '@angular/platform-browser';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
declare var $: any;
@Component({
  selector: 'app-place-of-application',
  templateUrl: './place-of-application.component.html',
  styleUrls: ['./place-of-application.component.scss']
})
export class PlaceOfApplicationComponent extends CoreComponent<PlaceOfApplication> {

  @Input() item: PlaceOfApplication = new PlaceOfApplication();
  validated= false;
  @ViewChild('ngForm', { static: false }) public ngForm: NgForm;
  @BlockUI() blockUI: NgBlockUI;
  constructor(protected servicesService: PlacesOfApplicationService, public route: ActivatedRoute,public activeModal: NgbActiveModal,
              protected gaService: GoogleAnalyticsService,

              private matSnackBar: MatSnackBar,private modalService: NgbModal, private router: Router,public meta: Meta, public title: Title) {
    super(servicesService,route);
    this.title.setTitle('Place Of Application');
  }

  onSubmit() {

    if (!this.ngForm.valid) {
      this.validated = true;
      $('html, body').animate({
        scrollTop: 0
      }, 1000, function() {
      });
      return;
    } else {
      this.blockUI.start();
      this.servicesService.save(this.item).subscribe((item: PlaceOfApplication) => {
        this.blockUI.stop();
        this.activeModal.close();
        this.item = item;

      },(error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        if (error.status === 401) {
          this.activeModal.close();
          this.router.navigate(['/']);
          this.matSnackBar.open('Your session has expired', 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }else {
          this.blockUI.stop();
          this.matSnackBar.open(error.error.message, 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      });
    }

  }
}
